{
  "acciones": {
    "guardar": "Guardar",
    "cancelar": "Cancelar",
    "buscar": "Buscar",
    "volver": "Volver",
    "confirmar": "Confirmar",
    "reintentar": "Reintentar",
    "salir": "Salir",
    "activar": "Activar",
    "desactivar": "Desactivar",
    "agregar": "Agregar",
    "siguiente": "Siguiente",
    "imprimir": "Imprimir",
    "quitar": "Quitar",
    "corregir": "Corregir"
  },
  "estados": {
    "cargando": "Cargando…",
    "vacio": "No hay nada para mostrar todavía",
    "error": "No se pudo completar la operación"
  },
  "tema": {
    "titulo": "Tema",
    "claro": "Claro",
    "oscuro": "Oscuro",
    "sistema": "El del sistema"
  },
  "idioma": {
    "titulo": "Idioma"
  },
  "salud": {
    "titulo": "Estado del sistema",
    "operativo": "Operativo",
    "degradado": "Degradado",
    "caido": "Fuera de servicio",
    "version": "Versión",
    "entorno": "Entorno",
    "tiempoActivo": "Tiempo activo",
    "segundos": "{{cantidad}} s",
    "sinConexion": "No se pudo consultar el estado del servidor",
    "estado": "Estado"
  },
  "navegacion": {
    "titulo": "Secciones",
    "contenido": "Contenido",
    "inicio": "Inicio",
    "sucursales": "Sucursales",
    "auditoria": "Auditoría",
    "empresaActiva": "Empresa activa",
    "estructura": "Depósitos y cajas",
    "gente": "Gente y roles",
    "configuracion": "Configuración",
    "catalogo": "Artículos",
    "precios": "Precios",
    "existencias": "Existencias",
    "caja": "Caja",
    "mostrador": "Mostrador",
    "mayorista": "Carga mayorista",
    "proveedores": "Proveedores",
    "compras": "Compras",
    "clientes": "Clientes",
    "cuentas": "Cuentas corrientes",
    "pagos": "Pagos a proveedores",
    "devoluciones": "Devoluciones",
    "contabilidad": "Plan de cuentas",
    "asientos": "Asientos",
    "libros": "Libros",
    "libroDeIva": "Libro de IVA",
    "ejercicios": "Ejercicios",
    "importacion": "Importar",
    "bancos": "Bancos",
    "comisiones": "Comisiones",
    "produccion": "Armado",
    "grupos": {
      "vender": "Vender",
      "stock": "Stock",
      "comprar": "Comprar",
      "plata": "Plata",
      "contabilidad": "Contabilidad",
      "configurar": "Configurar",
      "administrar": "Administrar"
    },
    "irA": "Ir a…",
    "irAAyuda": "Escribí el nombre de una pantalla",
    "irASinNada": "Ninguna pantalla se llama así.",
    "tiposDeComprobante": "Tipos de comprobante",
    "conversiones": "Facturar entregas",
    "rubros": "Rubros",
    "recalculo": "Recalcular precios",
    "numeradores": "Numeradores",
    "plegar": "Plegar el menú",
    "desplegar": "Desplegar el menú",
    "campos": "Campos propios",
    "plataforma": "Plataforma"
  },
  "acceso": {
    "subtitulo": "Ingresá con tu cuenta",
    "subtituloSegundoFactor": "Segundo paso",
    "correo": "Correo",
    "contrasena": "Contraseña",
    "codigo": "Código",
    "ayudaCodigo": "El de tu aplicación de autenticación, o uno de recuperación",
    "entrar": "Entrar",
    "confirmar": "Confirmar",
    "titulo": "Entrar",
    "presentacion": "Administración comercial para comercios que venden todos los días."
  },
  "empresa": {
    "elegir": "Elegí una empresa",
    "sinEmpresas": "Todavía no tenés ninguna empresa",
    "ayudaSinEmpresas": "Cuando des de alta tu comercio, va a aparecer acá.",
    "administrarPlataforma": "Administrar la plataforma",
    "suspendida": "Suspendida por la plataforma"
  },
  "inicio": {
    "descripcion": "Cómo viene el día.",
    "tuAcceso": "Tu acceso",
    "persona": "Persona",
    "permisos": "Permisos"
  },
  "sucursales": {
    "titulo": "Sucursales",
    "descripcion": "Los locales y depósitos de tu comercio.",
    "nueva": "Nueva sucursal",
    "ayudaNueva": "El código no se puede repetir dentro de la empresa.",
    "codigo": "Código",
    "nombre": "Nombre",
    "ciudad": "Ciudad",
    "estado": "Estado",
    "acciones": "Acciones",
    "activa": "Activa",
    "inactiva": "Inactiva",
    "ayudaCodigo": "Corto y fácil de decir en voz alta",
    "vacio": "Todavía no hay ninguna sucursal cargada."
  },
  "modulos": {
    "organizacion": "Organización",
    "accesos": "Accesos",
    "auditoria": "Auditoría",
    "existencias": "Existencias",
    "caja": "Caja",
    "impuestos": "Impuestos",
    "comisiones": "Comisiones",
    "cuentas-corrientes": "Cuentas corrientes",
    "comprobantes": "Comprobantes",
    "produccion": "Producción"
  },
  "opciones": {
    "FIFO": "FIFO",
    "PROMEDIO_PONDERADO": "Promedio ponderado",
    "MITAD_AFUERA": "Comercial",
    "MITAD_PAR": "Bancario",
    "AL_EMITIR": "Al emitir",
    "AL_COBRAR": "Al cobrar",
    "MANUAL": "Manual",
    "MAS_ANTIGUO_PRIMERO": "Al más antiguo",
    "A_CUENTA": "A cuenta",
    "EMISION": "Desde la emisión",
    "ENTREGA": "Desde la entrega",
    "es-AR": "Español",
    "en": "Inglés",
    "pt-BR": "Portugués"
  },
  "estructura": {
    "titulo": "Depósitos y cajas",
    "descripcion": "Todo lo que cuelga de una sucursal.",
    "depositos": "Depósitos",
    "ayudaDepositos": "Dónde se guarda la mercadería.",
    "cajas": "Puestos de caja",
    "ayudaCajas": "Los puestos donde se cobra.",
    "puntosDeVenta": "Puntos de venta",
    "ayudaPuntosDeVenta": "La numeración legal de los comprobantes corre por punto de venta, no por sucursal.",
    "nuevoDeposito": "Nuevo depósito",
    "nuevaCaja": "Nuevo puesto de caja",
    "nuevoPuntoDeVenta": "Nuevo punto de venta",
    "sinDepositos": "Todavía no hay depósitos.",
    "sinCajas": "Todavía no hay puestos de caja.",
    "sinPuntosDeVenta": "Todavía no hay puntos de venta.",
    "sucursal": "Sucursal",
    "elegirSucursal": "Elegí una sucursal",
    "codigo": "Código",
    "nombre": "Nombre",
    "numero": "Número",
    "modo": "Emisión",
    "predeterminado": "Predeterminado",
    "si": "Sí",
    "ayudaNumero": "El que asigna la administración fiscal",
    "modos": {
      "interno": "Interno",
      "manual": "Manual",
      "electronico": "Electrónico",
      "controlador_fiscal": "Controlador fiscal"
    },
    "corregir": "Corregir",
    "enUso": "En uso"
  },
  "gente": {
    "titulo": "Gente y roles",
    "descripcion": "Quién forma parte del comercio y qué puede hacer.",
    "equipo": "Equipo",
    "roles": "Roles",
    "ayudaRoles": "Un rol es un juego de permisos.",
    "persona": "Persona",
    "rol": "Rol",
    "alcance": "Sucursales",
    "estado": "Estado",
    "tipo": "Tipo",
    "permisos": "Permisos",
    "personas": "Personas",
    "activa": "Activa",
    "inactiva": "Inactiva",
    "deSistema": "Del sistema",
    "todasLasSucursales": "Todas",
    "invitar": "Invitar a alguien",
    "ayudaInvitar": "Le va a llegar un enlace para elegir su contraseña.",
    "correo": "Correo",
    "elegirRol": "Elegí un rol",
    "enviarInvitacion": "Invitar",
    "invitacionLista": "Invitación lista. Pasale este enlace:",
    "nuevoRol": "Nuevo rol",
    "ayudaNuevoRol": "Elegí qué puede hacer quien tenga este rol.",
    "codigoDelRol": "Código",
    "nombreDelRol": "Nombre",
    "tiposDeComprobante": "Comprobantes",
    "corregirPersona": "Corregir persona",
    "ayudaCorregirPersona": "El rol, hasta dónde llega y si sigue trabajando acá.",
    "corregirRol": "Corregir rol",
    "ayudaCorregirRol": "El nombre y qué puede hacer. El código no se cambia: lo nombran las reglas.",
    "estadoDeLaMembresia": "Sigue trabajando acá",
    "ayudaEstadoDeLaMembresia": "Al desactivarla no entra más. No se borra: lo que hizo sigue a su nombre.",
    "ayudaTodasLasSucursales": "Sin acotar, ve y opera en todas. Al acotar, sólo en las marcadas.",
    "sucursalPredeterminada": "Sucursal de siempre",
    "ayudaSucursalPredeterminada": "Con la que arranca al entrar. Sólo entre las que tiene permitidas.",
    "sinPredeterminada": "Que elija al entrar",
    "permisosDelDuenio": "El rol de dueño tiene todos los permisos y no se le sacan: una empresa sin dueño no se arregla desde adentro.",
    "eliminarRol": "Eliminar el rol",
    "confirmarEliminarRol": "Se elimina el rol. Sólo se puede si no lo tiene nadie.",
    "rolDeSistemaNoSeElimina": "Los roles que trae el sistema no se eliminan.",
    "sinAcotarSucursales": "Todas las sucursales",
    "sobreUnoMismo": "Sobre uno mismo no se cambia el rol ni se da de baja: quedarse afuera de la propia empresa no se arregla desde adentro."
  },
  "configuracion": {
    "titulo": "Configuración",
    "descripcion": "Cómo trabaja tu comercio.",
    "clases": {
      "libre": "Libre",
      "con_corte": "Requiere corte",
      "fijado_al_inicio": "Fijado al inicio"
    },
    "motivos": {
      "libre": "Rige de acá en adelante; no toca lo ya registrado.",
      "con_corte": "Cambiarlo reinterpreta operaciones ya registradas, así que todavía está bloqueado.",
      "fijado_al_inicio": "Se definió al dar de alta la empresa."
    },
    "datosDelComercio": "Los datos del comercio",
    "ayudaDatosDelComercio": "Lo que sale en los comprobantes y en el ticket. La identificación y la condición frente al IVA no se cambian desde acá: lo ya facturado las lleva."
  },
  "alta": {
    "titulo": "Damos de alta tu comercio",
    "crear": "Crear el comercio",
    "progreso": "Paso {{actual}} de {{total}}",
    "paso1": "Datos fiscales",
    "paso2": "Cómo trabajás",
    "paso3": "Tu primer local",
    "nombre": "Nombre del comercio",
    "ayudaNombre": "Como lo conoce la gente",
    "razonSocial": "Razón social",
    "ayudaRazonSocial": "Como figura en el papel",
    "ayudaIdentificacion": "Con o sin guiones. Por ejemplo: {{ejemplo}}",
    "tipoDeIdentificacion": "Tipo de identificación",
    "condicionIva": "Condición frente al fisco",
    "pais": "País",
    "jurisdiccion": "Provincia, región o departamento",
    "sinJurisdiccion": "Sin indicar",
    "monedaDelPais": "Opera en {{moneda}}, la moneda del país. Se fija al crear el comercio y no se cambia después.",
    "perfil": "Perfil de negocio",
    "elegirPerfil": "Elegí un perfil",
    "ayudaPerfil": "Deja la configuración lista; después se cambia lo que haga falta.",
    "sucursalNombre": "Nombre del local",
    "ayudaSucursal": "Casa central, sucursal centro, depósito…",
    "sucursalCiudad": "Ciudad",
    "loQueSeCrea": "Se crean también un depósito, una caja y un punto de venta, para que puedas empezar a operar.",
    "sucursalPorDefecto": "Casa central"
  },
  "perfiles": {
    "minorista_monotributo": "Minorista monotributista",
    "minorista_responsable_inscripto": "Minorista responsable inscripto",
    "mayorista": "Mayorista",
    "mixto": "Mixto"
  },
  "paises": {
    "AR": "Argentina",
    "CL": "Chile",
    "PY": "Paraguay",
    "UY": "Uruguay"
  },
  "jurisdicciones": {
    "AR-C": "Ciudad Autónoma de Buenos Aires",
    "AR-B": "Buenos Aires",
    "AR-K": "Catamarca",
    "AR-H": "Chaco",
    "AR-U": "Chubut",
    "AR-X": "Córdoba",
    "AR-W": "Corrientes",
    "AR-E": "Entre Ríos",
    "AR-P": "Formosa",
    "AR-Y": "Jujuy",
    "AR-L": "La Pampa",
    "AR-F": "La Rioja",
    "AR-M": "Mendoza",
    "AR-N": "Misiones",
    "AR-Q": "Neuquén",
    "AR-R": "Río Negro",
    "AR-A": "Salta",
    "AR-J": "San Juan",
    "AR-D": "San Luis",
    "AR-Z": "Santa Cruz",
    "AR-S": "Santa Fe",
    "AR-G": "Santiago del Estero",
    "AR-V": "Tierra del Fuego",
    "AR-T": "Tucumán",
    "CL-AP": "Arica y Parinacota",
    "CL-TA": "Tarapacá",
    "CL-AN": "Antofagasta",
    "CL-AT": "Atacama",
    "CL-CO": "Coquimbo",
    "CL-VS": "Valparaíso",
    "CL-RM": "Región Metropolitana de Santiago",
    "CL-LI": "Libertador General Bernardo O'Higgins",
    "CL-ML": "Maule",
    "CL-NB": "Ñuble",
    "CL-BI": "Biobío",
    "CL-AR": "La Araucanía",
    "CL-LR": "Los Ríos",
    "CL-LL": "Los Lagos",
    "CL-AI": "Aysén",
    "CL-MA": "Magallanes y de la Antártica Chilena",
    "PY-ASU": "Asunción",
    "PY-1": "Concepción",
    "PY-2": "San Pedro",
    "PY-3": "Cordillera",
    "PY-4": "Guairá",
    "PY-5": "Caaguazú",
    "PY-6": "Caazapá",
    "PY-7": "Itapúa",
    "PY-8": "Misiones",
    "PY-9": "Paraguarí",
    "PY-10": "Alto Paraná",
    "PY-11": "Central",
    "PY-12": "Ñeembucú",
    "PY-13": "Amambay",
    "PY-14": "Canindeyú",
    "PY-15": "Presidente Hayes",
    "PY-16": "Alto Paraguay",
    "PY-19": "Boquerón",
    "UY-AR": "Artigas",
    "UY-CA": "Canelones",
    "UY-CL": "Cerro Largo",
    "UY-CO": "Colonia",
    "UY-DU": "Durazno",
    "UY-FS": "Flores",
    "UY-FD": "Florida",
    "UY-LA": "Lavalleja",
    "UY-MA": "Maldonado",
    "UY-MO": "Montevideo",
    "UY-PA": "Paysandú",
    "UY-RN": "Río Negro",
    "UY-RV": "Rivera",
    "UY-RO": "Rocha",
    "UY-SA": "Salto",
    "UY-SJ": "San José",
    "UY-SO": "Soriano",
    "UY-TA": "Tacuarembó",
    "UY-TT": "Treinta y Tres"
  },
  "condicionesFiscales": {
    "AR": {
      "responsable_inscripto": "Responsable inscripto",
      "monotributo": "Monotributo",
      "exento": "Exento",
      "no_responsable": "No responsable",
      "consumidor_final": "Consumidor final",
      "no_categorizado": "No categorizado"
    },
    "CL": {
      "regimen_general": "Régimen general (art. 14 A)",
      "pro_pyme_general": "Pro Pyme general (art. 14 D N° 3)",
      "pro_pyme_transparente": "Pro Pyme transparente (art. 14 D N° 8)",
      "exento": "Exento de IVA",
      "contribuyente": "Contribuyente",
      "consumidor_final": "Consumidor final"
    },
    "PY": {
      "ire_general": "IRE régimen general",
      "ire_simple": "IRE SIMPLE",
      "ire_resimple": "IRE RESIMPLE",
      "contribuyente": "Contribuyente",
      "consumidor_final": "Consumidor final",
      "exento": "Exento"
    },
    "UY": {
      "regimen_general": "Régimen general (IRAE e IVA)",
      "literal_e": "Pequeña empresa (literal E)",
      "monotributo": "Monotributo",
      "monotributo_mides": "Monotributo social MIDES",
      "contribuyente": "Contribuyente",
      "consumidor_final": "Consumidor final",
      "exento": "Exento"
    }
  },
  "identificaciones": {
    "CUIT": "CUIT",
    "CUIL": "CUIL",
    "DNI": "DNI",
    "PASAPORTE": "Pasaporte",
    "OTRO": "Otro",
    "RUT": "RUT",
    "RUC": "RUC",
    "CI": "Cédula de identidad",
    "SIN_IDENTIFICAR": "Sin identificar"
  },
  "invitacion": {
    "titulo": "Te invitaron a un comercio",
    "tituloFundacion": "Bienvenido a ActualGold!",
    "subtitulo": "Elegí tu contraseña para entrar.",
    "subtituloFundacion": "Creá tu cuenta y después damos de alta tu comercio.",
    "nombre": "Nombre",
    "apellido": "Apellido",
    "contrasena": "Contraseña",
    "ayudaContrasena": "Al menos doce caracteres. Una frase es mejor que una palabra rara.",
    "aceptar": "Crear mi cuenta",
    "sinToken": "Este enlace no es válido. Pedí que te inviten de nuevo."
  },
  "permisos": {
    "EMPRESA": {
      "CONFIGURACION": {
        "VER": "Ver la configuración",
        "EDITAR": "Cambiar la configuración"
      },
      "SUCURSAL": {
        "VER": "Ver sucursales",
        "CREAR": "Crear sucursales",
        "EDITAR": "Editar sucursales"
      },
      "DEPOSITO": {
        "VER": "Ver depósitos",
        "CREAR": "Crear depósitos",
        "EDITAR": "Editar depósitos"
      },
      "PUESTO_DE_CAJA": {
        "VER": "Ver puestos de caja",
        "CREAR": "Crear puestos de caja",
        "EDITAR": "Editar puestos de caja"
      },
      "PUNTO_DE_VENTA": {
        "VER": "Ver puntos de venta",
        "CREAR": "Crear puntos de venta",
        "EDITAR": "Editar puntos de venta"
      },
      "MONEDA": {
        "VER": "Ver monedas",
        "EDITAR": "Editar monedas"
      },
      "COTIZACION": {
        "VER": "Ver cotizaciones",
        "CARGAR": "Cargar cotizaciones"
      },
      "CAMPO": {
        "VER": "Ver los campos propios",
        "ADMINISTRAR": "Definir los campos propios"
      },
      "EMPRESA": {
        "VER": "Ver los datos del comercio",
        "EDITAR": "Corregir los datos del comercio"
      }
    },
    "ACCESOS": {
      "ROL": {
        "VER": "Ver roles",
        "CREAR": "Crear roles",
        "EDITAR": "Editar roles",
        "ELIMINAR": "Eliminar roles"
      },
      "MEMBRESIA": {
        "VER": "Ver el equipo",
        "INVITAR": "Invitar gente",
        "EDITAR": "Editar el equipo",
        "DESACTIVAR": "Dar de baja gente"
      }
    },
    "AUDITORIA": {
      "REGISTRO": {
        "VER": "Ver la auditoría"
      }
    },
    "CATALOGO": {
      "ARTICULO": {
        "VER": "Ver artículos",
        "CREAR": "Crear artículos",
        "EDITAR": "Editar artículos"
      },
      "UNIDAD": {
        "VER": "Ver unidades de medida",
        "EDITAR": "Editar unidades de medida"
      },
      "CATEGORIA": {
        "VER": "Ver rubros",
        "EDITAR": "Editar rubros"
      }
    },
    "PRECIOS": {
      "LISTA": {
        "VER": "Ver listas de precios",
        "CREAR": "Crear listas de precios",
        "EDITAR": "Editar listas de precios"
      },
      "PRECIO": {
        "VER": "Ver precios",
        "EDITAR": "Cambiar precios"
      },
      "AUMENTO": {
        "APLICAR": "Aumentar una lista entera"
      }
    },
    "EXISTENCIAS": {
      "SALDO": {
        "VER": "Ver existencias"
      },
      "KARDEX": {
        "VER": "Ver los movimientos de stock"
      },
      "AJUSTE": {
        "APLICAR": "Ajustar existencias"
      },
      "COSTO": {
        "VER": "Ver el costo de las existencias"
      }
    },
    "CAJA": {
      "TURNO": {
        "VER": "Ver los turnos de caja",
        "ABRIR": "Abrir un turno de caja",
        "CERRAR": "Cerrar un turno de caja"
      },
      "MOVIMIENTO": {
        "REGISTRAR": "Registrar movimientos de caja"
      },
      "CONCEPTO": {
        "ADMINISTRAR": "Administrar los conceptos de caja"
      }
    },
    "VENTAS": {
      "COMPROBANTE": {
        "VER": "Ver comprobantes",
        "EMITIR": "Emitir comprobantes",
        "ANULAR": "Anular un comprobante"
      },
      "PRECIO": {
        "FORZAR": "Vender a un precio distinto del de la lista"
      },
      "DESCUENTO": {
        "APLICAR": "Aplicar bonificaciones en la venta"
      },
      "CREDITO": {
        "AUTORIZAR": "Autorizar una venta que se pasa del límite de crédito"
      },
      "DEVOLUCION": {
        "REGISTRAR": "Registrar una devolución",
        "AUTORIZAR_PLAZO": "Autorizar una devolución fuera de plazo"
      },
      "TIPO_DE_COMPROBANTE": {
        "VER": "Ver los tipos de comprobante",
        "ADMINISTRAR": "Configurar los tipos de comprobante"
      },
      "NUMERADOR": {
        "FIJAR": "Fijar en qué número va un numerador"
      }
    },
    "TERCEROS": {
      "TERCERO": {
        "VER": "Ver terceros",
        "CREAR": "Crear terceros",
        "EDITAR": "Editar terceros"
      },
      "PROVEEDOR": {
        "VER": "Ver proveedores",
        "EDITAR": "Editar el perfil de proveedor"
      },
      "CLIENTE": {
        "VER": "Ver clientes",
        "EDITAR": "Editar el perfil de cliente"
      }
    },
    "COMPRAS": {
      "ORDEN": {
        "VER": "Ver órdenes de compra",
        "CREAR": "Crear órdenes de compra",
        "EMITIR": "Emitir y anular órdenes"
      },
      "RECEPCION": {
        "VER": "Ver recepciones",
        "REGISTRAR": "Registrar recepciones",
        "ANULAR": "Anular una recepción"
      },
      "FACTURA": {
        "VER": "Ver facturas de proveedor",
        "REGISTRAR": "Registrar facturas de proveedor",
        "ANULAR": "Anular una factura de proveedor"
      },
      "GASTO": {
        "APLICAR": "Prorratear gastos sobre el costo"
      }
    },
    "CUENTAS": {
      "CUENTA": {
        "VER": "Ver cuentas corrientes"
      },
      "AJUSTE": {
        "APLICAR": "Ajustar un saldo de cuenta corriente"
      },
      "COBRO": {
        "REGISTRAR": "Registrar cobranzas",
        "ANULAR": "Anular una cobranza"
      },
      "PAGO": {
        "REGISTRAR": "Registrar pagos a proveedores",
        "ANULAR": "Anular un pago"
      }
    },
    "CONTABILIDAD": {
      "PLAN": {
        "VER": "Ver el plan de cuentas",
        "ADMINISTRAR": "Agregar y editar cuentas del plan"
      },
      "ASIENTO": {
        "VER": "Ver los asientos",
        "REGISTRAR": "Registrar asientos manuales"
      },
      "REGLA": {
        "ADMINISTRAR": "Configurar la imputación contable"
      },
      "LIBRO": {
        "VER": "Ver los libros contables"
      },
      "EJERCICIO": {
        "ADMINISTRAR": "Abrir, cerrar y reabrir ejercicios"
      }
    },
    "IMPUESTOS": {
      "LIBRO_DE_IVA": {
        "GENERAR": "Generar el Libro de IVA Digital"
      }
    },
    "IMPORTACION": {
      "LOTE": {
        "VER": "Ver las importaciones",
        "APLICAR": "Importar planillas",
        "REVERTIR": "Deshacer una importación"
      }
    },
    "BANCOS": {
      "CUENTA": {
        "VER": "Ver las cuentas bancarias",
        "ADMINISTRAR": "Administrar cuentas bancarias"
      },
      "VALOR": {
        "VER": "Ver la cartera de cheques",
        "MOVER": "Depositar, endosar y rechazar cheques"
      },
      "CONCILIACION": {
        "HACER": "Conciliar el extracto bancario"
      }
    },
    "COMISIONES": {
      "REGLA": {
        "ADMINISTRAR": "Configurar las comisiones"
      },
      "DEVENGAMIENTO": {
        "VER": "Ver lo que ganó cada vendedor"
      },
      "LIQUIDACION": {
        "HACER": "Liquidar comisiones"
      }
    },
    "PRODUCCION": {
      "RECETA": {
        "VER": "Ver las recetas de armado",
        "ADMINISTRAR": "Definir de qué se compone un combo"
      },
      "ARMADO": {
        "HACER": "Armar y desarmar combos"
      }
    },
    "INFORMES": {
      "TABLERO": {
        "VER": "Ver el tablero y los informes"
      }
    }
  },
  "parametros": {
    "empresa": {
      "zona_horaria": "Zona horaria",
      "idioma": "Idioma del sistema",
      "moneda_base": "Moneda base"
    },
    "impuestos": {
      "modo_de_redondeo": "Cómo se redondea"
    },
    "existencias": {
      "permitir_negativo": "Permitir vender sin existencia",
      "criterio_de_costeo": "Criterio de costeo"
    },
    "caja": {
      "exigir_turno_para_vender": "Exigir turno de caja abierto para vender"
    },
    "comisiones": {
      "momento_de_devengamiento": "Cuándo se gana la comisión"
    },
    "cuentas_corrientes": {
      "imputacion": "Cómo se imputan los pagos",
      "bloquear_por_mora": "Bloquear la venta a quien está en mora"
    },
    "devoluciones": {
      "dias_por_defecto": "Días para devolver",
      "plazo_desde": "El plazo corre"
    },
    "produccion": {
      "habilitada": "Producción habilitada"
    }
  },
  "catalogo": {
    "titulo": "Artículos",
    "descripcion": "Lo que el comercio vende y stockea.",
    "nuevo": "Nuevo artículo",
    "buscar": "Buscar por nombre o código",
    "codigo": "Código",
    "nombre": "Nombre",
    "marca": "Marca",
    "unidad": "Unidad",
    "tipo": "Tipo",
    "producto": "Producto",
    "servicio": "Servicio",
    "estado": "Estado",
    "activo": "Activo",
    "inactivo": "Inactivo",
    "variantes": "Variantes",
    "sinVariantes": "Sin variantes",
    "vacio": "Todavía no hay artículos cargados.",
    "ayudaCodigo": "El que se tipea en el mostrador. No se repite.",
    "ayudaUnidad": "Decide con cuántos decimales se puede vender: la unidad no admite fracciones, el metro sí.",
    "unidadDeStock": "Unidad de medida",
    "controlaExistencia": "Descuenta stock",
    "ayudaControlaExistencia": "Un servicio no descuenta stock; una mercadería sí.",
    "trazabilidad": "Trazabilidad",
    "trazabilidadNinguno": "Ninguna",
    "trazabilidadLote": "Por lote",
    "trazabilidadLoteConVencimiento": "Por lote con vencimiento",
    "trazabilidadSerie": "Por número de serie",
    "ayudaTrazabilidad": "Con vencimiento, el costo se consume por el que vence primero y no por el más viejo.",
    "esInsumo": "Sólo insumo",
    "ayudaEsInsumo": "Se compra y se produce con él, pero no se vende: no aparece en el mostrador.",
    "talles": "Talles",
    "colores": "Colores",
    "ayudaCombinaciones": "Separados por coma. Se crea una variante por cada cruce; si los dejás vacíos, el artículo tiene una sola.",
    "codigosDeBarra": "Códigos de barra",
    "ayudaCodigosDeBarra": "Separados por coma. Sólo si el artículo tiene una sola variante: con talles hay que cargarlos uno por uno desde la ficha.",
    "ficha": "Ficha del artículo",
    "agregarCodigo": "Agregar código de barras",
    "codigoDeBarra": "Código de barras",
    "talle": "Talle",
    "color": "Color",
    "sinDetalle": "—",
    "sinDecimales": "Esta unidad no admite fracciones: se vende de a números enteros.",
    "conDecimales": "Esta unidad admite hasta {{cantidad}} decimales en la cantidad.",
    "combinacionesQueSeCrean_one": "Se va a crear 1 variante",
    "combinacionesQueSeCrean_other": "Se van a crear {{count}} variantes",
    "variantesContadas_one": "1 variante",
    "variantesContadas_other": "{{count}} variantes",
    "corregirArticulo": "Corregir el artículo",
    "corregirAyuda": "Se cambia el catálogo de hoy. Los comprobantes ya emitidos siguen diciendo lo que decían.",
    "desactivar": "Desactivar",
    "activar": "Activar",
    "sinCodigoDeBarra": "Sin código de barras",
    "sacarCodigo": "Sacar",
    "paraLaVariante": "Para",
    "verCodigos": "Códigos"
  },
  "precios": {
    "titulo": "Precios",
    "descripcion": "A cuánto se vende cada cosa, en cada lista.",
    "lista": "Lista",
    "expresionNeto": "Precios sin IVA",
    "expresionFinal": "Precios con IVA incluido",
    "buscar": "Buscar por nombre o código",
    "articulo": "Artículo",
    "codigo": "Código",
    "unidad": "Unidad",
    "precio": "Precio",
    "desde": "Vigente desde",
    "sinPrecio": "Sin precio",
    "vacio": "No hay artículos para poner precio todavía.",
    "sinCambios": "Sin cambios para guardar",
    "aumentar": "Aumentar la lista",
    "porcentaje": "Porcentaje",
    "ayudaPorcentaje": "Con signo menos baja los precios. Se aplica sobre todos los que ya tienen precio en esta lista.",
    "redondeo": "Redondear a",
    "redondeoPeso": "Pesos enteros",
    "redondeoCentavo": "Dos decimales",
    "redondeoCuatro": "Cuatro decimales",
    "ayudaRedondeo": "El redondeo se declara siempre: aumentar 12% y dejar precios de $1.234,5678 es correcto y comercialmente inútil.",
    "historial": "Historial",
    "historialDe": "Historia del precio de {{articulo}}",
    "motivo": "Motivo",
    "anterior": "Anterior",
    "quien": "Quién",
    "motivoCarga": "Carga",
    "motivoCorreccion": "Corrección",
    "motivoAumentoDeLista": "Aumento de lista",
    "motivoImportacion": "Importación",
    "sinHistorial": "Este precio todavía no tiene historia.",
    "guardar_one": "Guardar 1 cambio",
    "guardar_other": "Guardar {{count}} cambios",
    "guardados_one": "Listo: 1 precio guardado.",
    "guardados_other": "Listo: {{count}} precios guardados.",
    "faltan_one": "Falta 1 sin precio",
    "faltan_other": "Faltan {{count}} sin precio",
    "aplicaA_one": "Va a cambiar 1 precio de esta lista.",
    "aplicaA_other": "Va a cambiar {{count}} precios de esta lista.",
    "aumentados_one": "Listo: 1 precio actualizado.",
    "aumentados_other": "Listo: {{count}} precios actualizados.",
    "costoDeReposicion": "Costo de reposición",
    "sinCosto": "Cargar",
    "cargarCosto": "Costo de reposición",
    "moneda": "Moneda",
    "ayudaCosto": "Lo que saldría comprarlo hoy. Es la base del recálculo de precios.",
    "esPredeterminada": "Predeterminada",
    "programar": "Programar",
    "programarPara": "Programar un precio para {{articulo}}",
    "ayudaProgramar": "El precio de hoy no cambia: el nuevo entra solo el día indicado, a primera hora, y queda en el historial.",
    "precioProgramado": "Precio nuevo",
    "desdeElDia": "Desde el día",
    "programados": "Precios programados",
    "ayudaProgramados": "Lo que entra solo en esta lista, y cuándo. Se puede cancelar mientras espera.",
    "precioDeHoy": "Precio de hoy",
    "motivoProgramado": "Programado"
  },
  "existencias": {
    "titulo": "Existencias",
    "descripcion": "Cuánto hay de cada cosa, dónde, y cuánto costó.",
    "deposito": "Depósito",
    "todos": "Todos los depósitos",
    "buscar": "Buscar por nombre o código",
    "codigo": "Código",
    "articulo": "Artículo",
    "unidad": "Unidad",
    "cantidad": "Cantidad",
    "valorizacion": "Valorizado",
    "vacio": "Todavía no hay existencia registrada.",
    "ajustar": "Ajustar existencia",
    "motivo": "Motivo",
    "ayudaMotivo": "Es obligatorio. Un ajuste sin motivo es un descuadre sin explicación, y a los tres meses nadie se acuerda de por qué faltaban seis.",
    "motivoExistenciaInicial": "Existencia inicial",
    "motivoConteo": "Diferencia de conteo",
    "motivoRotura": "Rotura",
    "motivoFaltante": "Faltante",
    "motivoSobrante": "Sobrante",
    "motivoUsoInterno": "Uso interno",
    "motivoDevolucionAProveedor": "Devolución a proveedor",
    "buscarArticulo": "Artículo",
    "ayudaCantidad": "Con signo menos para sacar.",
    "costoUnitario": "Costo unitario",
    "ayudaCosto": "Obligatorio al ingresar. Es lo que después va a decir cuánto costó lo que se venda.",
    "lote": "Lote",
    "vencimiento": "Vencimiento",
    "ayudaVencimiento": "Si se carga, esta mercadería sale antes que la que vence después, aunque haya entrado más tarde.",
    "agregarLinea": "Agregar línea",
    "quitar": "Quitar",
    "aplicar": "Aplicar el ajuste",
    "aplicado_other": "Listo: {{count}} movimientos registrados.",
    "kardex": "Movimientos",
    "kardexDe": "Movimientos de {{articulo}}",
    "cuando": "Cuándo",
    "origen": "Origen",
    "quien": "Quién",
    "observacion": "Observación",
    "origenAjuste": "Ajuste",
    "origenVenta": "Venta",
    "origenDevolucion": "Devolución",
    "origenCompra": "Compra",
    "origenTransferencia": "Transferencia",
    "origenProduccion": "Producción",
    "sinMovimientos": "Sin movimientos.",
    "entra": "Entra",
    "sale": "Sale",
    "aplicado_one": "Listo: {{count}} movimiento registrado."
  },
  "caja": {
    "titulo": "Caja",
    "descripcion": "El turno del puesto: lo que entró, lo que salió y cuánto tiene que haber.",
    "puesto": "Puesto de caja",
    "sinTurno": "Este puesto no tiene un turno abierto.",
    "abrir": "Abrir turno",
    "saldoInicial": "Efectivo en el cajón",
    "ayudaSaldoInicial": "Lo que hay ahora, contado. No se hereda del cierre anterior a propósito: heredarlo convierte el error de una noche en el punto de partida de la mañana.",
    "turnoNumero": "Turno {{numero}}",
    "abiertoPor": "Abierto por {{quien}}",
    "movimiento": "Registrar movimiento",
    "tipo": "Tipo",
    "ingreso": "Ingreso",
    "egreso": "Egreso",
    "medioDePago": "Medio de pago",
    "importe": "Importe",
    "concepto": "Concepto",
    "efectivo": "Efectivo",
    "debito": "Débito",
    "credito": "Crédito",
    "transferencia": "Transferencia",
    "cheque": "Cheque",
    "otro": "Otro",
    "cuando": "Cuándo",
    "quien": "Quién",
    "movimientos": "Movimientos del turno",
    "sinMovimientos": "Todavía no hay movimientos.",
    "arqueo": "Arqueo",
    "esperado": "Tiene que haber en efectivo",
    "ayudaArqueo": "Sólo se cuenta el efectivo. Lo cobrado con tarjeta o transferencia queda registrado, pero no está en el cajón.",
    "cerrar": "Cerrar turno",
    "declarado": "Efectivo contado",
    "ayudaDeclarado": "Lo que hay de verdad, contado ahora. Si no coincide, la diferencia queda registrada con tu nombre.",
    "observacion": "Observación",
    "ayudaObservacion": "Si hay diferencia, lo que sepas de por qué.",
    "diferencia": "Diferencia",
    "sobra": "Sobra",
    "falta": "Falta",
    "cuadra": "Cuadra exacto",
    "cerrado": "Listo: turno cerrado. Esperado {{esperado}}, contado {{declarado}}, diferencia {{diferencia}}.",
    "tipoApertura": "Apertura",
    "tipoVenta": "Venta",
    "tipoDevolucion": "Devolución",
    "tipoIngreso": "Ingreso",
    "tipoEgreso": "Egreso",
    "tipoRedondeo": "Redondeo",
    "tipoDiferenciaDeArqueo": "Diferencia de arqueo",
    "historia": "Turnos anteriores",
    "estado": "Estado",
    "estadoAbierto": "Abierto",
    "estadoCerrado": "Cerrado",
    "sinTurnos": "Todavía no se abrió ningún turno.",
    "turno": "Turno",
    "queEs": "¿Qué es?",
    "queGasto": "Un gasto o un ingreso",
    "quePago": "Un pago a un proveedor",
    "queCobro": "Un cobro a un cliente",
    "queDeposito": "Un depósito en el banco",
    "queDueno": "Un retiro o un aporte del dueño",
    "clasificarCon": "Se clasifica con",
    "conConcepto": "Un concepto",
    "conCuenta": "Una cuenta del plan",
    "conceptoDeCaja": "Concepto",
    "elegirConcepto": "Elegí un concepto",
    "cuentaDelPlan": "Cuenta",
    "elegirCuenta": "Elegí una cuenta",
    "ayudaCuenta": "Sólo las que se pueden mover desde la caja: no están la caja, los bancos, las cuentas corrientes, el stock ni el IVA, que se mueven con su propia operación.",
    "retiro": "Retiro",
    "aporte": "Aporte",
    "ayudaDueno": "Va contra la cuenta particular del dueño, en el patrimonio: no es un gasto del comercio.",
    "sinConceptoDelDueno": "Falta el concepto del dueño o está desactivado: revisalo en Configuración → Conceptos de caja.",
    "cuentaBancaria": "Cuenta bancaria",
    "elegirCuentaBancaria": "Elegí la cuenta",
    "sinCuentasBancarias": "No hay cuentas bancarias: se cargan en Bancos.",
    "ayudaDeposito": "Sale del cajón y entra a la cuenta hoy mismo.",
    "proveedor": "Proveedor",
    "cliente": "Cliente",
    "elegirTercero": "Elegí a quién",
    "ayudaTercero": "El efectivo pasa por el turno de {{puesto}}. Al lado de cada uno, cuánto se debe.",
    "sinProveedores": "No se le debe nada a ningún proveedor.",
    "sinClientes": "Ningún cliente debe nada.",
    "avisoIva": "Con factura A, cargala como factura de proveedor y pagala desde acá con «Un pago a un proveedor»: así se computa el IVA. Lo que se carga acá va entero al gasto.",
    "detalle": "Detalle",
    "ayudaDetalle": "Lo que haga falta para entenderlo después: a quién, por qué.",
    "seguir": "Seguir",
    "revertir": "Revertir",
    "confirmarReversion": "¿Revertir «{{concepto}}»? Se registra el movimiento inverso, con su asiento, y el original queda a la vista.",
    "tipoCobranza": "Cobranza",
    "tipoPago": "Pago",
    "tipoDeposito": "Depósito"
  },
  "venta": {
    "mostrador": "Mostrador",
    "mayorista": "Carga mayorista",
    "descripcionMostrador": "Pasá el lector o buscá por nombre. Todo se opera con el teclado.",
    "descripcionMayorista": "Código, cantidad y bonificación. Enter agrega y sigue.",
    "buscar": "Código, código de barras o nombre",
    "codigo": "Código",
    "articulo": "Artículo",
    "cantidad": "Cantidad",
    "precio": "Precio",
    "bonificacion": "Bonif. %",
    "importe": "Importe",
    "quitar": "Quitar",
    "vacia": "La venta está vacía. Pasá el lector o escribí un código.",
    "subtotal": "Subtotal",
    "descuento": "Bonificaciones",
    "redondeo": "Redondeo",
    "total": "Total",
    "medioDePago": "Cómo paga",
    "efectivo": "Efectivo",
    "debito": "Débito",
    "credito": "Crédito",
    "transferencia": "Transferencia",
    "entregado": "Con cuánto paga",
    "vuelto": "Vuelto",
    "falta": "Falta",
    "cobrar": "Cobrar",
    "cancelar": "Cancelar la venta",
    "cobrada": "Comprobante {{clase}} {{numero}} cobrado por {{total}}.",
    "vueltoDe": "Vuelto: {{importe}}",
    "sinTurno": "No hay turno de caja abierto en este puesto. Abrilo antes de vender.",
    "irACaja": "Ir a Caja",
    "sinResultados": "Ningún artículo coincide.",
    "atajos": "F2 cobra · Esc limpia la búsqueda · Supr quita la línea",
    "atajosMayorista": "Enter agrega y vuelve al código · F2 cobra · Esc vacía la venta",
    "agregar": "Agregar",
    "puesto": "Puesto de caja",
    "lista": "Lista de precios",
    "ultimoTicket": "Último: ticket {{numero}} por {{total}}",
    "sinPrecio": "Sin precio cargado",
    "menosUno": "Quitar uno",
    "masUno": "Agregar uno",
    "sinPrecioEnLista": "El artículo {{codigo}} no tiene precio en esta lista. Cargalo antes de venderlo.",
    "cliente": "Cliente",
    "consumidorFinal": "Consumidor final",
    "buscarCliente": "Buscar cliente",
    "quitarCliente": "Quitar el cliente",
    "clase": "Comprobante {{clase}}",
    "claseExplicacion": "La letra sale de la condición frente al IVA del comercio y la del cliente. No se elige.",
    "sinClientesQueCoincidan": "Ningún cliente coincide.",
    "debeEnCuenta": "Debe {{importe}} en cuenta",
    "sinDeuda": "Sin deuda",
    "cuenta_corriente": "Cuenta corriente",
    "necesitaCliente": "Para vender en cuenta hay que identificar al cliente.",
    "autorizarExceso": "Autorizar y cobrar igual",
    "excesoNoAutorizado": "Sólo un encargado puede autorizar que se pase del límite.",
    "anular": "Anular esta venta",
    "motivoDeAnulacion": "Por qué se anula",
    "confirmarAnulacion": "Anular",
    "tipoDeComprobante": "Qué se emite",
    "sinCobro": "Este documento no cobra",
    "emitir": "Emitir",
    "dividirElPago": "Dividir el pago",
    "quitarForma": "Quitar esta forma de pago",
    "sobra": "Sobra",
    "queSeEmite": "Qué se emite",
    "listaFijadaPorElTipo": "La fija el tipo de comprobante.",
    "cajaFijadaPorElTipo": "La fija el tipo de comprobante.",
    "conLaLista": "Precios de la lista {{lista}}"
  },
  "ticket": {
    "imprimir": "Imprimir",
    "numero": "Ticket {{numero}}",
    "noFiscal": "Documento no válido como factura",
    "subtotal": "Subtotal",
    "descuento": "Bonificaciones",
    "redondeo": "Redondeo",
    "total": "TOTAL",
    "qr": "Código para consultar el ticket",
    "consultaConQr": "Escaneá el código para volver a ver este ticket",
    "verTicket": "Ver el ticket",
    "cliente": "Cliente: {{nombre}}",
    "cuit": "CUIT {{cuit}}",
    "identificacion": "{{tipo}} {{numero}}",
    "domicilio": "Domicilio: {{domicilio}}",
    "codigoDeTipo": "Cód. {{codigo}}",
    "fechaDeEmision": "Fecha de emisión",
    "puntoDeVenta": "Punto de venta",
    "original": "ORIGINAL",
    "receptor": "Receptor",
    "sinIdentificar": "Sin identificar",
    "neto": "Neto gravado",
    "netoPorAlicuota": "Neto al {{alicuota}} %",
    "ivaPorAlicuota": "IVA {{alicuota}} %",
    "ivaIncluido": "IVA {{alicuota}} % incluido",
    "ivaTotal": "Total IVA",
    "verEnHoja": "Ver en hoja A4",
    "verEnRollo": "Ver en rollo de 80 mm",
    "cae": "CAE Nº {{cae}}",
    "caeVencimiento": "Vto. del CAE: {{fecha}}",
    "sinCae": "Comprobante pendiente de autorización",
    "qrDelOrganismo": "Código QR de la factura electrónica",
    "notaDeCredito": "NOTA DE CRÉDITO",
    "ajusta": "Ajusta el comprobante {{comprobante}}"
  },
  "compras": {
    "proveedores": "Proveedores",
    "compras": "Compras",
    "descripcionProveedores": "A quién le compra el comercio.",
    "descripcionCompras": "Lo que pedí, lo que llegó y lo que me cobraron.",
    "nuevoProveedor": "Nuevo proveedor",
    "razonSocial": "Razón social",
    "nombreComercial": "Cómo lo llaman",
    "ayudaNombreComercial": "Es lo que se tipea al buscarlo.",
    "tipoDeIdentificacion": "Tipo",
    "identificacion": "Identificación",
    "ayudaIdentificacion": "Se guarda sólo con dígitos. Se puede escribir con guiones.",
    "condicionIva": "Condición frente al IVA",
    "diasDePago": "Días de pago",
    "ayudaDiasDePago": "Cero es contado. De acá sale el vencimiento de cada factura.",
    "monedaDelProveedor": "Moneda",
    "telefono": "Teléfono",
    "correo": "Correo",
    "ciudad": "Ciudad",
    "esProveedor": "Proveedor",
    "sinProveedores": "Todavía no hay proveedores.",
    "buscarProveedor": "Buscar por nombre o identificación",
    "ordenes": "Órdenes de compra",
    "nuevaOrden": "Nueva orden",
    "orden": "Orden",
    "proveedor": "Proveedor",
    "fecha": "Fecha",
    "estado": "Estado",
    "total": "Total",
    "estadoBorrador": "Borrador",
    "estadoEmitida": "Emitida",
    "estadoParcial": "Parcial",
    "estadoCumplida": "Cumplida",
    "estadoAnulada": "Anulada",
    "emitir": "Emitir",
    "anular": "Anular",
    "sinOrdenes": "Todavía no hay órdenes de compra.",
    "articulo": "Artículo",
    "cantidad": "Cantidad",
    "precioUnitario": "Precio",
    "bonificacion": "Bonif. %",
    "importe": "Importe",
    "agregar": "Agregar",
    "quitar": "Quitar",
    "buscarArticulo": "Código o nombre del artículo",
    "recepciones": "Recepciones",
    "nuevaRecepcion": "Registrar recepción",
    "remito": "Remito del proveedor",
    "deposito": "Depósito",
    "costoUnitario": "Costo",
    "lote": "Lote",
    "vencimiento": "Vencimiento",
    "sinRecepciones": "Todavía no llegó nada.",
    "recibida": "Recepción {{numero}} registrada. La orden quedó {{estado}}.",
    "recibidaSinOrden": "Recepción {{numero}} registrada.",
    "facturas": "Facturas de proveedor",
    "nuevaFactura": "Registrar factura",
    "letra": "Letra",
    "puntoDeVenta": "Punto de venta",
    "numero": "Número",
    "neto": "Neto",
    "iva": "IVA",
    "percepciones": "Percepciones",
    "vencimientoDePago": "Vence",
    "sinFacturas": "Todavía no hay facturas cargadas.",
    "conDiferencias": "Con diferencias",
    "sinDiferencias": "Coincide",
    "verCotejo": "Ver el cotejo",
    "cotejo": "Cotejo contra lo recibido",
    "facturado": "Facturado",
    "recibido": "Recibido",
    "difNoRecibido": "No llegó",
    "difFacturadoDeMas": "Facturaron de más",
    "difFacturadoDeMenos": "Facturaron de menos",
    "difPrecioDistinto": "Otro precio",
    "sinFacturar": "Llegó y no lo facturaron",
    "coincide": "Coincide",
    "gasto": "Prorratear un gasto",
    "concepto": "Concepto",
    "criterio": "Repartir",
    "porImporte": "Por importe",
    "porCantidad": "Por cantidad",
    "ayudaCriterio": "Por importe cuando el gasto acompaña al valor; por cantidad cuando lo que se paga es el camión.",
    "gastoAplicado": "Listo. El stock absorbió {{absorbido}} y {{noAbsorbido}} es mayor costo del período.",
    "ayudaNoAbsorbido": "Lo que corresponde a mercadería ya vendida no se puede absorber: el costo de aquellas ventas ya está registrado.",
    "costoYMargen": "Costo y margen",
    "ultimaCompra": "Última compra",
    "costoDelStock": "Cuesta lo que tengo",
    "costoDeReposicion": "Reposición",
    "precioDeVenta": "Precio de venta",
    "margenReal": "Margen realizado",
    "vendidoCantidad": "Vendido",
    "ingreso": "Ingreso",
    "ayudaMargenReal": "Sale de los comprobantes emitidos, sobre el neto sin IVA. Las devoluciones restan.",
    "sinDatos": "Sin datos todavía.",
    "ivaCobrado": "IVA cobrado (no es ingreso)"
  },
  "clientes": {
    "titulo": "Clientes",
    "descripcion": "A quién le vende el comercio. Un mismo tercero puede ser cliente y proveedor.",
    "nuevoCliente": "Nuevo cliente",
    "buscar": "Buscar cliente",
    "sinClientes": "Todavía no hay clientes cargados.",
    "razonSocial": "Razón social",
    "nombreComercial": "Nombre comercial",
    "ayudaNombreComercial": "Cómo lo llaman. Es lo que se tipea al buscarlo.",
    "tipoDeIdentificacion": "Tipo de identificación",
    "identificacion": "Identificación",
    "ayudaIdentificacion": "Escribila como está en el papel, con guiones o sin ellos.",
    "condicionIva": "Condición frente al IVA",
    "limiteDeCredito": "Límite de crédito",
    "ayudaLimite": "Cero es no fiarle. Vacío también.",
    "sinLimite": "Sin límite",
    "noSeLeFia": "No se le fía",
    "diasDePago": "Días de pago",
    "ayudaDiasDePago": "Cero es contado.",
    "contado": "Contado",
    "tambienProveedor": "También",
    "esProveedor": "Proveedor",
    "telefono": "Teléfono",
    "correo": "Correo",
    "seguimiento": "Seguimiento",
    "filtrarPorEtiqueta": "Filtrar por etiqueta",
    "todasLasEtiquetas": "Todas"
  },
  "cuentas": {
    "titulo": "Cuentas corrientes",
    "descripcion": "Quién debe y cuánto, de mayor a menor.",
    "cliente": "Cliente",
    "identificacion": "Identificación",
    "saldo": "Saldo",
    "limite": "Límite",
    "sinLimite": "Sin límite",
    "aFavor": "{{importe}} a favor",
    "acciones": "Acciones",
    "verFicha": "Ver la ficha",
    "ajustar": "Ajustar",
    "nadieDebe": "Nadie debe nada.",
    "ajustarSaldo": "Ajustar el saldo",
    "importeDelAjuste": "Importe",
    "ayudaImporteDelAjuste": "Con signo: positivo sube la deuda, negativo la baja.",
    "motivo": "Motivo",
    "ayudaMotivo": "Queda escrito en el libro y en la auditoría.",
    "tipos": {
      "venta": "Venta",
      "cobro": "Cobro",
      "ajuste": "Ajuste"
    },
    "cobrar": "Cobrar",
    "cobranza": "Cobranza a {{cliente}}",
    "medioDePago": "Medio de pago",
    "importe": "Importe",
    "agregarMedio": "Agregar otro medio",
    "quitarMedio": "Quitar",
    "pendientes": "Comprobantes con deuda",
    "sinPendientes": "No tiene comprobantes pendientes. Lo que se cobre queda a cuenta.",
    "pendiente": "Le falta",
    "aImputar": "Se aplica",
    "totalCobrado": "Total cobrado",
    "totalImputado": "Aplicado a comprobantes",
    "aCuenta": "Adelantado y sin aplicar",
    "propuesta": "Propuesto: lo más viejo primero. Se puede cambiar.",
    "registrar": "Registrar el cobro",
    "cobrado": "Recibo {{numero}} por {{total, importe}}. Saldo: {{saldo, importe}}.",
    "observaciones": "Observaciones",
    "enCaja": "Entra al turno de caja abierto",
    "estadoDeCuenta": "Estado de cuenta",
    "comoCliente": "Cuenta como cliente",
    "comoProveedor": "Cuenta como proveedor",
    "fecha": "Fecha",
    "concepto": "Concepto",
    "acumulado": "Saldo",
    "vence": "Vence",
    "antiguedad": "Antigüedad",
    "alDia": "Al día",
    "hasta30": "1 a 30",
    "hasta60": "31 a 60",
    "hasta90": "61 a 90",
    "masDe90": "Más de 90",
    "verEstado": "Estado de cuenta",
    "porTramos": "Deuda por antigüedad",
    "anular": "Anular",
    "motivoDeAnulacion": "Por qué se anula",
    "confirmarAnulacion": "Confirmar la anulación",
    "anulado": "Anulado",
    "anulada": "Anulada",
    "numeroDeCheque": "Número del cheque",
    "bancoDelCheque": "Banco",
    "fechaDeCobro": "Fecha de cobro",
    "recibo": "Recibo {{numero}}",
    "aplicar": "Aplicar"
  },
  "pagos": {
    "titulo": "Pagos a proveedores",
    "descripcion": "A quién le debe el comercio, de mayor a menor.",
    "proveedor": "Proveedor",
    "pagar": "Pagar",
    "orden": "Orden de pago a {{proveedor}}",
    "facturas": "Facturas pendientes",
    "sinFacturas": "No hay facturas pendientes. Lo que se pague queda a cuenta.",
    "registrar": "Registrar el pago",
    "pagado": "Orden {{numero}} por {{total, importe}}. Saldo: {{saldo, importe}}.",
    "nadieCobra": "No se le debe nada a nadie.",
    "sale": "Sale del turno de caja abierto",
    "endosar": "Endosar cheques de la cartera",
    "sinCartera": "No hay cheques en la cartera.",
    "seCobra": "Se cobra",
    "totalEndosado": "Total endosado"
  },
  "devoluciones": {
    "titulo": "Devoluciones",
    "descripcion": "El cliente trajo mercadería: se busca la venta y se devuelve lo que corresponde.",
    "buscar": "Número de ticket",
    "buscarAyuda": "Es el número que está impreso en el papel.",
    "sinResultados": "Ninguna venta con ese número.",
    "venta": "Ticket {{numero}}",
    "fecha": "Fecha",
    "total": "Total",
    "cliente": "Cliente",
    "consumidorFinal": "Consumidor final",
    "elegir": "Devolver de esta venta",
    "articulo": "Artículo",
    "vendida": "Vendida",
    "yaDevuelta": "Ya devuelta",
    "disponible": "Queda",
    "aDevolver": "Se devuelve",
    "motivo": "Por qué se devuelve",
    "registrar": "Registrar la devolución",
    "hecha": "Devolución {{numero}} por {{total, importe}}. En efectivo: {{enEfectivo, importe}}. A favor: {{aCuenta, importe}}.",
    "fueraDePlazo": "Autorizar y devolver igual",
    "sinAutorizacion": "Sólo un encargado puede autorizar una devolución fuera de plazo.",
    "nadaQueDevolver": "De esta venta ya se devolvió todo.",
    "cambiar": "Cambiar por otro artículo",
    "loQueSeLleva": "Lo que se lleva",
    "buscarArticulo": "Buscar el artículo que se lleva",
    "diferenciaAPagar": "El cliente paga",
    "diferenciaADevolver": "Se le devuelve",
    "sinDiferencia": "Sin diferencia",
    "registrarCambio": "Registrar el cambio",
    "soloDevolver": "Sólo devolver",
    "cambioHecho": "Cambio hecho: devolución {{devolucion}} y ticket {{venta}}. Diferencia: {{diferencia, importe}}.",
    "hechaComoNota": "Nota de crédito {{numero}} por {{total, importe}}. En efectivo: {{enEfectivo, importe}}. A favor: {{aCuenta, importe}}."
  },
  "contabilidad": {
    "titulo": "Plan de cuentas",
    "descripcion": "Dónde se imputa cada cosa que pasa en el comercio.",
    "nueva": "Nueva cuenta",
    "ayudaNueva": "Cuelga de la cuenta que elijas y hereda su tipo.",
    "codigo": "Código",
    "nombre": "Nombre",
    "tipo": "Tipo",
    "cuelgaDe": "Cuelga de",
    "ninguna": "Ningún rubro",
    "imputable": "Imputable",
    "agrupacion": "Agrupación",
    "desactivar": "Desactivar",
    "activar": "Activar",
    "inactiva": "Inactiva",
    "renombrar": "Cambiar nombre",
    "ayudaRenombrar": "El código {{codigo}} no cambia. Los libros de todos los períodos la van a mostrar con el nombre nuevo.",
    "vacio": "Todavía no hay cuentas cargadas.",
    "ayudaTipo": "Sólo lo elige un rubro de arriba de todo; una cuenta que cuelga de otra hereda el suyo.",
    "tipos": {
      "activo": "Activo",
      "pasivo": "Pasivo",
      "patrimonio": "Patrimonio neto",
      "resultado_positivo": "Resultado positivo",
      "resultado_negativo": "Resultado negativo"
    }
  },
  "asientos": {
    "titulo": "Asientos",
    "descripcion": "Cómo quedó registrada contablemente cada operación.",
    "numero": "Número",
    "fecha": "Fecha",
    "glosa": "Concepto",
    "importe": "Importe",
    "cuenta": "Cuenta",
    "debe": "Debe",
    "haber": "Haber",
    "verOperacion": "Ver la operación",
    "vacio": "Todavía no hay asientos.",
    "totales": "Totales",
    "cuadra": "Cuadra",
    "tipo": "Tipo",
    "tipos": {
      "venta": "Venta",
      "devolucion": "Devolución",
      "cobranza": "Cobranza",
      "pago": "Pago",
      "recepcion": "Recepción",
      "factura_de_compra": "Factura de compra",
      "diferencia_de_caja": "Diferencia de caja"
    },
    "referencias": {
      "comprobante": "Comprobante",
      "recepcion": "Recepción",
      "factura_de_proveedor": "Factura del proveedor",
      "recibo_de_cobranza": "Recibo de cobranza",
      "orden_de_pago": "Orden de pago",
      "turno_de_caja": "Turno de caja"
    }
  },
  "libros": {
    "titulo": "Libros contables",
    "descripcion": "El diario, el mayor, las sumas y saldos y el estado de resultados, por período.",
    "libro": {
      "diario": "Diario",
      "mayor": "Mayor",
      "sumas": "Sumas y saldos",
      "resultados": "Resultados"
    },
    "desde": "Desde",
    "hasta": "Hasta",
    "cuenta": "Cuenta",
    "nombre": "Nombre",
    "elegirCuenta": "Elegí una cuenta",
    "numero": "Número",
    "fecha": "Fecha",
    "glosa": "Concepto",
    "importe": "Importe",
    "debe": "Debe",
    "haber": "Haber",
    "acumulado": "Saldo",
    "saldoAnterior": "Saldo anterior",
    "saldoFinal": "Saldo final",
    "saldoDeudor": "Saldo deudor",
    "saldoAcreedor": "Saldo acreedor",
    "totales": "Totales",
    "cuadra": "Cuadra",
    "noCuadra": "No cuadra",
    "positivos": "Resultados positivos",
    "negativos": "Resultados negativos",
    "totalPositivos": "Total de resultados positivos",
    "totalNegativos": "Total de resultados negativos",
    "ganancia": "Ganancia del período",
    "perdida": "Pérdida del período",
    "planilla": "Bajar planilla",
    "vacio": "No hubo movimientos en este período."
  },
  "libroDeIva": {
    "titulo": "Libro de IVA Digital",
    "descripcion": "Los archivos de la RG 4597 para presentar el período ante ARCA.",
    "periodo": "Período",
    "generar": "Generar",
    "bajar": "Bajar",
    "renglones": "{{renglones}} renglones",
    "registros": "{{total}} comprobantes",
    "sinMovimientos": "Sin movimientos",
    "todaviaNada": "Elegí un período y generá el libro.",
    "avisoDeCodificacion": "Los archivos se bajan en ISO 8859-1, como pide el régimen. No los vuelvas a guardar en UTF-8: en un archivo de posiciones fijas un acento de más corre todo el renglón y el organismo lo rechaza entero."
  },
  "ejercicios": {
    "titulo": "Ejercicios",
    "descripcion": "El período contable, su cierre, y los asientos que escribe una persona.",
    "nombre": "Nombre",
    "periodo": "Período",
    "estado": "Estado",
    "estados": {
      "abierto": "Abierto",
      "cerrado": "Cerrado"
    },
    "abrir": "Abrir ejercicio",
    "cerrar": "Cerrar",
    "reabrir": "Reabrir",
    "reabrirAyuda": "No se borra nada: se escriben los asientos inversos del cierre y de la refundición, y queda registrado quién y por qué.",
    "motivo": "Motivo",
    "cerrado": "Cerrado. Resultado del ejercicio: {{resultado}}.",
    "asientoManual": "Asiento manual",
    "asientoManualAyuda": "El único asiento que no nace de una operación. Por eso queda con tu nombre y su motivo.",
    "fecha": "Fecha",
    "glosa": "Concepto",
    "cuenta": "Cuenta",
    "lado": "Lado",
    "elegirCuenta": "Elegí una cuenta",
    "otroRenglon": "Otro renglón",
    "desde": "Desde",
    "hasta": "Hasta",
    "vacio": "Todavía no hay ejercicios. Abrí uno para poder cerrar el año."
  },
  "respaldos": {
    "titulo": "Respaldo de los datos",
    "ultimo": "Último respaldo: {{cuando}}",
    "verificado": "Verificado",
    "sinVerificar": "No se pudo verificar",
    "afuera": "Copiado fuera de la máquina",
    "noSubio": "No se pudo copiar afuera",
    "soloAca": "Sólo en esta máquina",
    "ninguno": "Todavía no se hizo ningún respaldo."
  },
  "preparacion": {
    "titulo": "Para poder operar",
    "todoListo": "Todo listo",
    "todoListoAyuda": "El comercio tiene todo lo que necesita para vender.",
    "puedeOperar": "Se puede vender",
    "noPuedeOperar": "Todavía no se puede vender",
    "resolver": "Resolver",
    "yMas": "y {{total}} más",
    "estados": {
      "falta": "Falta",
      "atencion": "Atención",
      "listo": "Listo"
    },
    "requisitos": {
      "SUCURSAL": "Una sucursal activa",
      "DEPOSITO": "Un depósito donde tener la mercadería",
      "PUNTO_DE_VENTA": "Un punto de venta para emitir comprobantes",
      "PUESTO_DE_CAJA": "Un puesto de caja",
      "LISTA_DE_PRECIOS": "Una lista de precios",
      "ARTICULO": "Al menos un artículo en el catálogo",
      "PRECIO": "Precios cargados: un artículo sin precio no se puede vender",
      "PLAN_DE_CUENTAS": "El plan de cuentas",
      "EJERCICIO": "Un ejercicio contable abierto que incluya hoy",
      "CERTIFICADO_FISCAL": "El certificado para pedir el CAE: sin él los comprobantes no se autorizan",
      "REGLAS_DE_IMPUTACION": "Reglas de imputación contable: sin ellas la operación se cae al confirmarla"
    }
  },
  "importacion": {
    "titulo": "Importar",
    "descripcion": "Cargar el catálogo desde una planilla, sin escribir nada hasta confirmar.",
    "elegirArchivo": "Elegí la planilla",
    "leyendo": "Leyendo…",
    "vistaPrevia": "Esto es lo que va a pasar",
    "aCrear": "{{total}} se dan de alta",
    "aOmitir": "{{total}} ya existen",
    "conError": "{{total}} no entran",
    "comoSeLeyo": "Se leyó como {{codificacion}}, separado por «{{separador}}». Columnas: {{columnas}}.",
    "linea": "Línea",
    "clave": "Código",
    "desenlace": "Qué pasa",
    "desenlaces": {
      "crear": "Se crea",
      "omitir": "Ya existe",
      "error": "No entra"
    },
    "confirmar": "Importar {{total}}",
    "nadaSeEscribio": "Todavía no se escribió nada.",
    "listo": "Importado",
    "resumen": "{{creadas}} creadas · {{omitidas}} omitidas · {{conError}} con error",
    "anteriores": "Importaciones anteriores",
    "sinLotes": "Todavía no se importó nada.",
    "archivo": "Archivo",
    "cuando": "Cuándo",
    "quien": "Quién",
    "resultado": "Resultado",
    "entidades": {
      "articulos": "Artículos",
      "precios": "Precios",
      "existencias": "Existencias",
      "terceros": "Clientes y proveedores"
    },
    "ayudas": {
      "articulos": "Columnas: código y nombre, y opcionalmente unidad, IVA y marca.",
      "precios": "Columnas: código del artículo y precio, y opcionalmente la lista. Acepta 1.200,50.",
      "existencias": "Columnas: código del artículo, cantidad y costo, y opcionalmente el depósito. Se registra como existencia inicial, con su movimiento, su capa de costo y su asiento.",
      "terceros": "Columnas: razón social, y opcionalmente CUIT, condición frente al IVA y si es cliente o proveedor."
    },
    "elOrden": "El orden importa: primero los artículos, después sus precios y sus existencias. Los clientes y proveedores van cuando quieras.",
    "deshacer": "Deshacer",
    "revertido": "Deshecho",
    "deshecho": "Se deshicieron {{total}} filas."
  },
  "bancos": {
    "titulo": "Bancos",
    "descripcion": "Dónde está la plata que no es efectivo.",
    "enElBanco": "En el banco",
    "enTransito": "Depositado, sin acreditar",
    "enCartera": "En cartera",
    "cuentas": "Cuentas",
    "cuenta": "Cuenta",
    "banco": "Banco",
    "numero": "Número",
    "saldo": "Saldo",
    "cartera": "Cheques en cartera",
    "cheque": "Cheque",
    "deQuien": "De quién",
    "fechaDeCobro": "Se cobra el",
    "importe": "Importe",
    "fecha": "Fecha",
    "estado": "Estado",
    "depositos": "Depósitos",
    "acreditar": "Acreditar",
    "acreditadoEl": "Acreditado el {{fecha}}",
    "depositarEn": "Depositar {{total}} en {{cuenta}}",
    "depositarAyuda": "La plata no entra al banco hasta que lo acredites: son dos momentos.",
    "sinCuentas": "Todavía no hay cuentas bancarias.",
    "sinValores": "No hay cheques en cartera.",
    "sinDepositos": "Todavía no se depositó nada.",
    "conciliacion": "Conciliación",
    "elegiCuenta": "Elegí una cuenta.",
    "subirExtracto": "Subir el extracto (CSV)",
    "extractoCargado": "Se cargaron {{cargadas}} líneas y se descartaron {{rechazadas}}.",
    "diceElBanco": "Lo que dice el banco y el sistema no explica",
    "diceElSistema": "Lo que dice el sistema y el banco no confirma",
    "todoExplicado": "No queda nada del banco sin explicar.",
    "todoConfirmado": "No queda nada del sistema sin confirmar.",
    "sinCandidato": "Sin candidato",
    "conciliar": "Es este",
    "nombre": "Nombre",
    "agregarCuenta": "Agregar cuenta"
  },
  "comisiones": {
    "titulo": "Comisiones",
    "descripcion": "Lo que ganó cada vendedor, y lo que falta pagarle.",
    "pendiente": "Pendiente de liquidar",
    "vendedor": "Vendedor",
    "operaciones": "Operaciones",
    "total": "Total",
    "liquidar": "Liquidar",
    "hasta": "Hasta",
    "avisoDeLiquidar": "Lo que se liquida no se recalcula. Si aparece algo después, entra en la próxima.",
    "reglas": "Reglas",
    "categoria": "Categoría",
    "todas": "Todas",
    "porcentaje": "Porcentaje",
    "sobreElNeto": "El porcentaje se aplica sobre el neto, sin IVA. La regla de una categoría manda sobre la base del vendedor.",
    "liquidaciones": "Liquidaciones",
    "periodo": "Período",
    "sinPendientes": "No hay comisiones pendientes.",
    "sinReglas": "Todavía no se configuró ninguna comisión.",
    "sinLiquidaciones": "Todavía no se liquidó nada."
  },
  "produccion": {
    "titulo": "Armado de combos",
    "descripcion": "Juntar componentes en un producto que se vende como uno solo.",
    "recetas": "Recetas",
    "combo": "Combo",
    "componentes": "Componentes",
    "componente": "Componente",
    "porCombo": "Por combo",
    "elegir": "Elegir",
    "elegiUno": "Elegí un combo de la lista.",
    "armar": "Armar",
    "cantidad": "Cantidad",
    "deposito": "Depósito",
    "costo": "Costo",
    "quien": "Quién",
    "desarmar": "Desarmar",
    "esUnDesarmado": "Es un desarmado",
    "historial": "Armados",
    "sinArmados": "Todavía no se armó nada.",
    "sinRecetas": "Ningún artículo tiene receta.",
    "comoSeCarga": "Una receta declara de qué se compone un combo y en qué cantidades.",
    "armado": "Armado. Costó {{costo}}.",
    "costoSaleDeAhi": "El costo del combo es el de las capas que se consumieron, no un promedio."
  },
  "tablero": {
    "elDia": "El día",
    "vendido": "Vendido",
    "margen": "Margen",
    "operaciones": "Operaciones",
    "contraAyer": "{{valor}} % vs ayer",
    "promedio": "Promedio del mes",
    "plata": "Dónde está la plata",
    "enCaja": "En caja",
    "enBanco": "En el banco",
    "enCartera": "En cartera",
    "enTransito": "En tránsito",
    "deDondeSale": "La caja es la de los turnos abiertos. El banco y los cheques son de toda la empresa, no de una sucursal.",
    "cobrar": "Por cobrar",
    "pendiente": "Pendiente",
    "vencido": "Vencido",
    "faltantes": "Se quedó sin stock",
    "faltantesExplicacion": "Artículos en cero que se vendieron en los últimos 30 días.",
    "vendidas": "{{cuantas}} en 30 días",
    "porSucursal": "Por sucursal",
    "sucursal": "Sucursal",
    "contraAyerCorto": "vs ayer",
    "porciento": "{{valor}} %",
    "sucursalEnCero": "La sucursal que no vendió aparece en cero: eso también es información.",
    "hoy": "Hoy",
    "ayer": "Ayer",
    "concepto": "Concepto",
    "detalle": "Detalle",
    "valor": "Valor",
    "planilla": "Planilla"
  },
  "terceros": {
    "corregir": "Corregir los datos",
    "corregirAyuda": "Se corrige la ficha. Los comprobantes ya emitidos guardan los datos que tenían ese día."
  },
  "tiposDeComprobante": {
    "titulo": "Tipos de comprobante",
    "descripcion": "Qué documentos emite el comercio y qué hace cada uno.",
    "codigo": "Código",
    "nombre": "Nombre",
    "signo": "Impacto",
    "queHace": "Qué hace",
    "estado": "Estado",
    "suma": "Suma",
    "resta": "Resta",
    "noImpacta": "No impacta",
    "mueveStock": "Movimiento de stock",
    "ninguno": "No mueve stock",
    "descuenta": "Descuenta stock",
    "ingresa": "Ingresa stock",
    "esValorizado": "Lleva importes",
    "esValorizadoAyuda": "Un remito puede no llevarlos.",
    "haceIva": "Declara IVA",
    "haceIvaAyuda": "Entra al libro de IVA del mes.",
    "haceContabilidad": "Asienta",
    "haceContabilidadAyuda": "Deja su asiento contable.",
    "tocaCaja": "Toca la caja",
    "tocaCajaAyuda": "Mueve el turno abierto.",
    "afectaCuenta": "Mueve la cuenta",
    "afectaCuentaAyuda": "Cambia lo que el tercero debe.",
    "pideCae": "Pide CAE",
    "pideCaeAyuda": "Se autoriza ante el organismo.",
    "numeraPorPunto": "Numera por punto de venta",
    "numeraPorPuntoAyuda": "Cada punto lleva su propia numeración.",
    "enUso": "En uso",
    "apagado": "Apagado",
    "encender": "Encender",
    "apagar": "Apagar",
    "nuevo": "Nuevo tipo",
    "corregir": "Corregir el tipo",
    "rigeDesdeAhora": "Lo que cambies rige para los próximos. Los comprobantes ya emitidos quedan como están.",
    "laLetraNoSeElige": "La letra del comprobante no se configura: sale de la RG 1415 según tu condición y la del cliente.",
    "circuito": "Circuito",
    "deQueNace": "De qué nace {{nombre}}",
    "circuitoAyuda": "Los documentos marcados se pueden convertir en éste. Una factura nace de un remito.",
    "listaDePrecios": "Lista de precios",
    "laQueElComercioTenga": "La que el comercio tenga puesta",
    "listaDePreciosAyuda": "Con qué precios se emite este tipo.",
    "listaEsFija": "La lista no se cambia",
    "listaEsFijaAyuda": "Quien emite no puede vender con otra lista.",
    "requiereOrigen": "Requiere documento previo",
    "requiereOrigenAyuda": "No se emite suelto: nace de alguno de los tipos del circuito.",
    "dejaPendiente": "Queda pendiente hasta que se convierta",
    "dejaPendienteAyuda": "Un documento de este origen aparece en Inicio hasta que exista su destino.",
    "tiposDelRol": "Qué tipos puede usar",
    "todosLosTipos": "Sin marcar ninguno, puede usar todos.",
    "numerador": "Numerador",
    "numeradorAyuda": "De qué talonario toma el número. Varios tipos pueden usar el mismo.",
    "elDeSuFamilia": "El de su familia fiscal",
    "puestoDeCaja": "Caja en la que incide",
    "puestoDeCajaAyuda": "Con una caja fija, quien vende no la elige.",
    "laQueElijaQuienVende": "La que elija quien vende"
  },
  "conversiones": {
    "titulo": "Facturar lo entregado",
    "descripcion": "Los documentos que salieron y todavía no se facturaron.",
    "queSeEmite": "Qué se emite",
    "facturar": "Facturar {{cuantos}}",
    "total": "Total",
    "nadaPendiente": "No queda nada por facturar.",
    "sinCliente": "Sin cliente",
    "documentos": "documentos del mismo cliente",
    "numero": "Comprobante {{numero}}",
    "hecho": "Listo: se emitió el comprobante {{numero}}.",
    "sinCircuito": "Todavía no hay ningún circuito armado.",
    "comoSeArma": "En Tipos de comprobante, decile a un tipo de qué otros puede nacer.",
    "enCuenta": "Se emite en cuenta corriente: el cobro va después, por su camino."
  },
  "rubros": {
    "titulo": "Rubros",
    "descripcion": "Cómo se agrupan los artículos. Uno puede estar en varios.",
    "nuevo": "Nuevo rubro",
    "corregir": "Corregir rubro",
    "nombre": "Nombre",
    "articulos": "Artículos",
    "estado": "Estado",
    "activo": "Activo",
    "inactivo": "Inactivo",
    "activar": "Activar",
    "desactivar": "Desactivar",
    "cuelgaDe": "Cuelga de",
    "sinPadre": "No cuelga de ninguno",
    "ayudaCuelgaDe": "«Oro 18k» adentro de «Oro»: se busca por el de arriba y aparecen los de abajo.",
    "vacio": "Todavía no hay rubros",
    "paraQueSirven": "Agrupan los artículos para buscarlos, ponerles precio y pagar comisión.",
    "delArticulo": "Rubros",
    "ningunoElegido": "Sin rubro",
    "filtrar": "Filtrar por rubro",
    "todos": "Todos los rubros"
  },
  "recalculo": {
    "titulo": "Recalcular precios",
    "descripcion": "El precio sale del costo, no de un número escrito a mano.",
    "lista": "Lista",
    "base": "De dónde sale el precio",
    "baseCosto": "Del costo de reposición",
    "basePrecio": "Del precio que ya tiene",
    "ayudaCosto": "Lo que saldría comprarlo hoy, con la utilidad encima.",
    "ayudaPrecio": "Un porcentaje sobre el precio vigente. Es el aumento parejo de siempre.",
    "utilidad": "Utilidad sobre el costo (%)",
    "aumento": "Aumento (%)",
    "ayudaUtilidad": "Costo 100 con 40% da 140. No es lo mismo que margen sobre la venta, que se ve en la tabla.",
    "redondeo": "Redondeo",
    "valor": "Valor",
    "redondeoDecimales": "Decimales",
    "redondeoMultiplo": "A múltiplo de",
    "redondeoTerminacion": "Terminado en",
    "aQuienesAlcanza": "A quiénes alcanza",
    "proveedor": "Proveedor",
    "rubro": "Rubro",
    "marca": "Marca",
    "todosLosProveedores": "Todos",
    "todosLosRubros": "Todos",
    "ayudaProveedor": "Sale del historial de compras: los que alguna vez se le compraron.",
    "verQuePasaria": "Ver qué pasaría",
    "aplicar": "Aplicar a {{count}}",
    "aplicar_one": "Aplicar a 1 precio",
    "aplicar_other": "Aplicar a {{count}} precios",
    "noEscribeNada": "Mirar no cambia nada.",
    "aplicado": "Se actualizó {{count}} precio.",
    "aplicado_one": "Se actualizó 1 precio.",
    "aplicado_other": "Se actualizaron {{count}} precios.",
    "codigo": "Código",
    "articulo": "Artículo",
    "costo": "Costo",
    "precioAnterior": "Precio de ahora",
    "precioNuevo": "Precio nuevo",
    "margenSobreVenta": "Margen s/ venta",
    "sinPrecio": "Sin precio",
    "sinCosto": "Falta el costo",
    "sinPrecioBase": "No tiene precio del que partir",
    "cambian": "Cambian",
    "quedanAfuera": "{{count}} quedan afuera",
    "quedanAfuera_one": "1 queda afuera",
    "quedanAfuera_other": "{{count}} quedan afuera",
    "cotizacionUsada": "{{moneda}} a {{valor}}",
    "ningunaAlcanzada": "El filtro no alcanza a ninguna variante",
    "aflojaElFiltro": "Probá sin proveedor, o sin rubro: se combinan con «y».",
    "aplicarEl": "Aplicar el",
    "ayudaAplicarEl": "Vacío, ahora. Con una fecha, los precios nuevos quedan programados y entran solos ese día.",
    "programado_one": "Listo: {{count}} precio programado para el {{fecha}}.",
    "programado_other": "Listo: {{count}} precios programados para el {{fecha}}.",
    "programado": "Listo: {{count}} precios programados para el {{fecha}}."
  },
  "seguimiento": {
    "titulo": "Seguimiento",
    "tipo": "Qué fue",
    "quePaso": "Qué pasó",
    "volverEl": "Volver el",
    "ayudaVolverEl": "Con fecha, queda pendiente y aparece en Inicio.",
    "anotar": "Anotar",
    "queSePaso": "Lo que pasó",
    "sinNotas": "Todavía no hay nada anotado.",
    "personas": "Personas",
    "nombre": "Nombre",
    "cargo": "Cargo",
    "telefono": "Teléfono",
    "etiquetas": "Etiquetas",
    "sinEtiquetas": "Todavía no hay etiquetas creadas.",
    "venceEl": "Vence {{fecha}}",
    "hecho": "Hecho",
    "marcarHecho": "Marcar hecho",
    "tipos": {
      "llamada": "Llamada",
      "visita": "Visita",
      "correo": "Correo",
      "mensaje": "Mensaje",
      "nota": "Nota"
    }
  },
  "pendientes": {
    "titulo": "Qué hay que hacer",
    "vencido": "Vencido",
    "vencidos": "{{count}} vencidos",
    "vencidos_one": "1 vencido",
    "vencidos_other": "{{count}} vencidos"
  },
  "circuito": {
    "titulo": "Lo que falta documentar",
    "esperan": "{{tipo}} esperando su {{destino}}",
    "resolver": "Resolver"
  },
  "numeradores": {
    "titulo": "Numeradores",
    "descripcion": "Los talonarios del comercio. Cualquier comprobante puede usar cualquiera.",
    "nuevo": "Nuevo numerador",
    "corregir": "Corregir numerador",
    "codigo": "Código",
    "nombre": "Nombre",
    "codigoAyuda": "Corto y en mayúsculas. Es lo que queda impreso en el comprobante.",
    "puntoDeVenta": "Punto de venta",
    "puntoAyuda": "De acá salen las cuatro cifras. No se cambia después.",
    "puntoNoSeCambia": "El punto de venta no se cambia: sus cuatro cifras están impresas en cada comprobante que emitió.",
    "vaPor": "Va por",
    "tiposQueLoUsan": "Tipos",
    "estado": "Estado",
    "activo": "Activo",
    "inactivo": "Inactivo",
    "activar": "Activar",
    "desactivar": "Desactivar",
    "fijar": "Fijar el número",
    "ultimoNumero": "Último número emitido",
    "fijarAyuda": "Sólo hacia adelante: retroceder repetiría números ya emitidos.",
    "vacio": "Todavía no hay numeradores",
    "paraQueSirven": "Cada tipo de comprobante toma su número de uno. Sin ninguno, numeran como siempre."
  },
  "campos": {
    "titulo": "Campos propios",
    "descripcion": "Los datos que tu comercio necesita y ninguna ficha traía.",
    "nuevo": "Nuevo campo",
    "corregir": "Corregir campo",
    "deQueFicha": "De qué ficha",
    "nombre": "Nombre",
    "codigo": "Código",
    "codigoAyuda": "Con el que se lo va a buscar. Se propone solo desde el nombre.",
    "tipo": "Tipo",
    "tipoAyuda": "El tipo no se cambia después: se desactiva el campo y se crea otro.",
    "tipoNoSeCambia": "El tipo no se cambia: convertiría los valores ya cargados en otra cosa.",
    "opciones": "Opciones",
    "opcionesAyuda": "Una por línea.",
    "opcionEnUso": "Una opción elegida en alguna ficha no se puede sacar.",
    "ayuda": "Ayuda",
    "obligatorio": "Obligatorio",
    "obligatorioAyuda": "Sin valor no se puede guardar la ficha.",
    "estado": "Estado",
    "activo": "Activo",
    "inactivo": "Inactivo",
    "activar": "Activar",
    "desactivar": "Desactivar",
    "si": "Sí",
    "vacio": "Todavía no hay campos propios",
    "paraQueSirven": "Agregá los datos que tu comercio necesita y ninguna ficha traía.",
    "enLaFicha": "Campos propios",
    "entidades": {
      "articulo": "Artículos",
      "tercero": "Clientes y proveedores"
    },
    "tipos": {
      "texto": "Texto",
      "texto_largo": "Texto largo",
      "texto_enriquecido": "Texto con formato",
      "numero": "Número",
      "fecha": "Fecha",
      "si_no": "Sí o no",
      "lista": "Lista desplegable",
      "imagen": "Imagen",
      "archivo": "Archivo"
    },
    "verElArchivo": "Ver el archivo",
    "sacarElArchivo": "Sacarlo",
    "elegirArchivo": "Elegir archivo",
    "cambiarArchivo": "Cambiar",
    "subiendo": "Subiendo…"
  },
  "ficha": {
    "datos": "Datos",
    "unidadFija": "Se mide en {{unidad}}. La unidad no se cambia: reinterpretaría las cantidades ya registradas.",
    "variante": "Variante",
    "existencias": "Cuánto hay",
    "sinExistencias": "Todavía no hay existencia de esto",
    "porVariante": "De la primera variante.",
    "precios": "A cuánto se vende",
    "ayudaPrecios": "En cada lista, y dónde falta cargarlo.",
    "sinPrecio": "Sin precio",
    "sinPrecios": "Todavía no hay listas de precios",
    "movimientos": "Qué se movió",
    "ayudaMovimientos": "Todas las entradas y salidas, de todos los depósitos.",
    "sinMovimientos": "Todavía no se movió",
    "compras": "A quién se le compró",
    "ayudaCompras": "De las recepciones, que son las que traen la mercadería.",
    "sinCompras": "Todavía no se compró",
    "quienLoLleva": "Quién lo lleva",
    "ayudaQuienLoLleva": "Clientes con nombre. Las ventas de mostrador sin cliente no cuentan.",
    "sinClientes": "Todavía no lo llevó ningún cliente",
    "importe": "Importe",
    "ultimaVez": "Última vez",
    "gestionar": "Gestionar",
    "tambienProveedor": "También es proveedor",
    "tambienCliente": "También es cliente",
    "perfilDeCliente": "Cuánto se le fía",
    "ayudaPerfilDeCliente": "El tope de la cuenta corriente.",
    "limiteVacio": "En blanco es sin tope. Cero es no fiarle.",
    "perfilDeProveedor": "Cómo se le paga",
    "ayudaPerfilDeProveedor": "Los días desde la factura hasta el vencimiento.",
    "cuentaCorriente": "Cuenta corriente",
    "ayudaCuentaCliente": "Lo que debe como cliente. No se compensa con lo que se le debe.",
    "ayudaCuentaProveedor": "Lo que se le debe como proveedor. No se compensa con lo que debe.",
    "sinCuenta": "Todavía no hay movimientos",
    "comprobantes": "Qué se le vendió",
    "ayudaComprobantes": "Los últimos comprobantes, anulados incluidos.",
    "sinComprobantes": "Todavía no se le vendió",
    "queSeLleva": "Qué se lleva",
    "ayudaQueSeLleva": "Por artículo, de lo que más gasta a lo que menos.",
    "sinVentas": "Todavía no se llevó nada",
    "ayudaSeguimiento": "Qué pasó con este cliente y qué hay que hacer después.",
    "seguimientoAparte": "La bitácora y los pendientes se abren en su propia ventana.",
    "ayudaOrdenes": "Lo que se le pidió.",
    "sinOrdenes": "Todavía no se le pidió nada",
    "ayudaRecepciones": "Lo que llegó de verdad.",
    "sinRecepciones": "Todavía no llegó nada",
    "ayudaFacturas": "Lo que cobró, con las diferencias marcadas.",
    "sinFacturas": "Todavía no facturó",
    "listaDePrecios": "Lista de precios",
    "ayudaListaDePrecios": "Si tiene una, se le vende con ésa mientras esté activa y en fecha, salvo que el tipo de comprobante fije otra.",
    "listaQueNoSirve": "Esa lista hoy no se ofrece —está desactivada o fuera de fecha—: mientras tanto se le vende con la que siga en la cadena.",
    "sinListaPropia": "La que le toque"
  },
  "plataforma": {
    "titulo": "Plataforma",
    "descripcion": "Quién entra a esta instalación. Lo que pasa adentro de cada comercio no se ve desde acá.",
    "invitaciones": "Invitaciones a fundar un comercio",
    "ayudaInvitaciones": "Cada una es un enlace de una sola vez, con catorce días de vigencia.",
    "invitar": "Invitar a fundar un comercio",
    "ayudaInvitar": "La persona acepta, elige su clave y carga los datos de su comercio, que conoce mejor que nosotros.",
    "correo": "Correo",
    "comercio": "Comercio",
    "ayudaComercio": "Cómo se llama, si se sabe. Es para reconocer la invitación en la lista.",
    "notas": "Notas",
    "emitir": "Emitir la invitación",
    "invitacionLista": "La invitación está emitida. El enlace se muestra acá para pasarlo por donde sea —correo, mensaje, en persona—: no depende de que ningún correo haya salido.",
    "enlace": "Enlace",
    "emitida": "Emitida",
    "vence": "Vence",
    "estado": "Estado",
    "estados": {
      "pendiente": "Pendiente",
      "aceptada": "Aceptada",
      "revocada": "Revocada",
      "vencida": "Vencida"
    },
    "revocar": "Revocar",
    "sinInvitaciones": "Todavía no se invitó a nadie",
    "sinComercio": "Sin nombre todavía",
    "quienSos": "Entraste como administrador de la plataforma.",
    "comercios": "Comercios",
    "ayudaComercios": "Que existen y si están activos. Lo que tienen adentro no se ve desde acá.",
    "nombre": "Comercio",
    "identificacion": "Identificación",
    "fundado": "Fundado",
    "activo": "Activo",
    "suspendido": "Suspendido",
    "suspender": "Suspender",
    "reactivar": "Reactivar",
    "confirmarSuspension": "Nadie va a poder entrar, y quien esté adentro se queda afuera en el próximo pedido. No se borra nada.",
    "sinComercios": "Todavía no hay comercios",
    "administradores": "Quiénes administran la instalación",
    "ayudaAdministradores": "Se nombran y se quitan por consola, en el servidor. Desde acá sólo se ven.",
    "nuevoComercio": "Nuevo comercio",
    "ayudaNuevoComercio": "Se crea con su sucursal, sus roles y su dueño listo para entrar. Es el mismo alta que fundarlo por invitación.",
    "elComercio": "El comercio",
    "elDuenio": "Quien lo va a manejar",
    "sucursal": "Primera sucursal",
    "correoDelDuenio": "Correo del dueño",
    "nombreDelDuenio": "Nombre del dueño",
    "claveDelDuenio": "Clave inicial",
    "ayudaClaveDelDuenio": "Quién maneja este comercio, y dos formas de restablecerle la clave. Es la cuenta de la persona: si es dueña de otro comercio, la clave cambia para los dos.",
    "crear": "Crear el comercio",
    "comercioCreado": "El comercio está creado. Estos son los datos para entrar; la clave no se vuelve a mostrar.",
    "comercioCreadoConCuenta": "El comercio está creado y se le sumó a la cuenta que ya tenía ese correo: entra con su clave de siempre.",
    "entrarEn": "Entra en",
    "editar": "Editar",
    "editarComercio": "Editar el comercio",
    "ayudaEditarComercio": "La ficha. La identificación y la condición frente al IVA no se cambian: lo ya facturado las lleva.",
    "domicilio": "Domicilio",
    "ciudad": "Ciudad",
    "codigoPostal": "Código postal",
    "telefono": "Teléfono",
    "correoDelComercio": "Correo del comercio",
    "borrar": "Borrar",
    "ayudaBorrar": "Se borra con todo lo suyo: ventas, gente, archivos. No hay vuelta. Sólo un comercio suspendido, y escribiendo su identificación.",
    "escribiLaIdentificacion": "Escribí la identificación para confirmar",
    "borrarDefinitivamente": "Borrar definitivamente",
    "sinDuenios": "Este comercio no tiene dueño activo",
    "claveProvisoria": "Poner una clave provisoria",
    "ayudaClaveProvisoria": "Se le cierran todas las sesiones y al entrar tiene que elegir la suya. Se muestra una sola vez.",
    "generarOtra": "Generar otra",
    "aplicar": "Aplicar",
    "provisoriaPuesta": "Clave provisoria puesta. Pasásela; al entrar tiene que cambiarla.",
    "enlaceDeRecuperacion": "Generar un enlace",
    "ayudaEnlaceDeRecuperacion": "La persona elige su clave con el enlace. La clave nunca pasa por vos. Vence, y se usa una vez.",
    "enlaceListo": "Enlace listo. Pasáselo por donde sea.",
    "restablecerClave": "Clave del dueño"
  },
  "clave": {
    "miClave": "Cambiar mi clave",
    "titulo": "Cambiar la clave",
    "ayuda": "Con la actual y la nueva. Las otras sesiones de tu cuenta se cierran; ésta sigue.",
    "actual": "Clave actual",
    "nueva": "Clave nueva",
    "repetir": "Repetí la clave nueva",
    "ayudaNueva": "12 caracteres o más. Una frase que sólo vos sepas.",
    "noCoinciden": "Las dos claves nuevas no coinciden.",
    "cambiar": "Cambiar la clave",
    "cambiada": "La clave quedó cambiada.",
    "elegi": "Elegí tu clave",
    "ayudaElegi": "Entraste con una clave provisoria. Antes de seguir, elegí una que sólo vos sepas: la provisoria va en «clave actual»."
  },
  "recuperacion": {
    "titulo": "Elegí tu clave nueva",
    "ayuda": "Este enlace se usa una sola vez.",
    "listo": "La clave quedó cambiada. Ya podés entrar.",
    "entrar": "Ir a entrar",
    "sinToken": "Este enlace no trae ningún código. Pedí uno nuevo.",
    "confirmar": "Guardar la clave"
  },
  "listasDePrecios": {
    "titulo": "Listas de precios",
    "descripcion": "Con qué precios se vende. La venta toma la del cliente, la del tipo de comprobante, la de la caja o la de la sucursal, y si no hay ninguna, la predeterminada.",
    "nueva": "Nueva lista",
    "corregir": "Corregir la lista",
    "codigo": "Código",
    "nombre": "Nombre",
    "moneda": "Moneda",
    "expresionDelPrecio": "El precio es",
    "ayudaExpresion": "Final: lo que paga el cliente, con IVA. Neto: sin IVA, como se piensa por mayor.",
    "expresion": {
      "final": "Precio final",
      "neto": "Precio neto"
    },
    "vigencia": "Vigencia",
    "siempre": "Siempre",
    "desde": "Desde el {{desde}}",
    "hasta": "Hasta el {{hasta}}",
    "entre": "Del {{desde}} al {{hasta}}",
    "vigenteDesde": "Vale desde",
    "vigenteHasta": "Vale hasta",
    "ayudaVigencia": "Sin fechas, vale siempre. Fuera de fecha no se ofrece, y quien la tenga asignada vende con la siguiente.",
    "tramos": "Tramos",
    "sinTramos": "—",
    "tramo": "desde {{desde}}: {{porcentaje}} %",
    "tramosDe": "Tramos por cantidad de {{lista}}",
    "ayudaTramos": "Un descuento por cantidad para todos los artículos de la lista: desde 10 unidades, 5 % menos. Vale el tramo más alto que alcanza la línea.",
    "desdeCantidad": "Desde la cantidad",
    "descuento": "Descuento %",
    "agregarTramo": "Agregar tramo",
    "estado": "Estado",
    "predeterminada": "Predeterminada",
    "activa": "Activa",
    "inactiva": "Inactiva",
    "fueraDeFecha": "Fuera de fecha",
    "hacerPredeterminada": "Hacer predeterminada",
    "eliminar": "Eliminar",
    "desactivar": "Desactivar",
    "activar": "Activar",
    "eliminada": "Lista eliminada.",
    "desactivada": "La lista ya vendió, así que quedó desactivada: no se ofrece más y sus ventas siguen diciendo con qué lista se hicieron.",
    "copiarDe": "Copiar los precios de",
    "sinCopiar": "No copiar: empezar vacía",
    "ayudaCopiar": "La nueva hereda la moneda y la expresión de la que se copia.",
    "porcentaje": "Porcentaje",
    "ayudaPorcentaje": "Sobre el precio de la otra lista. Con signo menos es una rebaja: -15.",
    "redondearA": "Redondear a múltiplo de",
    "ayudaRedondeo": "Vacío, a dos decimales. 10 deja los precios terminados en cero, nunca para abajo.",
    "copiados": "Lista creada con {{cantidad}} precios copiados.",
    "vacio": "Todavía no hay listas.",
    "predeterminadaSinVigencia": "La predeterminada no tiene vigencia: es la que asegura que siempre haya un precio.",
    "asignada": "Lista de precios"
  },
  "cajaDelEfectivo": {
    "etiqueta": "Caja del efectivo",
    "elegir": "Elegí la caja",
    "ayuda": "El efectivo pasa por el turno abierto de esa caja, y el arqueo lo cuenta.",
    "sinCajas": "No hay ninguna caja con turno abierto: el efectivo no pasa por ningún turno.",
    "fija": "El efectivo pasa por el turno de {{puesto}}."
  },
  "conceptosDeCaja": {
    "titulo": "Conceptos de caja",
    "descripcion": "Por qué entra o sale plata del cajón cuando no es una venta. Quien carga elige el concepto; la cuenta contable se elige acá, una vez.",
    "nombre": "Nombre",
    "sentido": "Para",
    "cuenta": "Cuenta contable",
    "cuentaNoDisponible": "La cuenta ya no admite movimientos de caja: elegí otra.",
    "estado": "Estado",
    "activo": "Activo",
    "inactivo": "Desactivado",
    "corregir": "Corregir",
    "ayudaCorregir": "Cambiar la cuenta rige para los próximos movimientos: lo ya asentado no se reescribe.",
    "nuevo": "Nuevo concepto de caja",
    "vacio": "Todavía no hay conceptos.",
    "sentidos": {
      "egreso": "Egresos",
      "ingreso": "Ingresos",
      "ambos": "Los dos"
    }
  }
}
